import useApplication from "features/ecommerce/useOnboardingApplication";
import type { WithApplication } from "./types";

export const useOnboardingApplication = ({
    getApplicationModel
}: WithApplication) => {
    const { isApplicationStarted, isApplicationSubmitted } = useApplication();

    const isApplicationCompleted = () => {
        for (const {
            countable = true,
            isIncomplete,
            hasRequestedChange
        } of Array.from(getApplicationModel().values())) {
            if (!countable) {
                continue;
            }

            if (isIncomplete || hasRequestedChange) {
                return false;
            }
        }

        return true;
    };

    return {
        isApplicationStarted,
        isApplicationCompleted,
        isApplicationSubmitted
    };
};

export default useOnboardingApplication;
